"use client"

import React from 'react'
import { useTranslations } from 'next-intl'
import { UIInput, type UIInputProps } from './ui-input'
import { cn } from '../../lib/utils'

export interface UIInputRingProps extends Omit<UIInputProps, 'type' | 'placeholder'> {
  type?: 'email' | 'text' | 'password'
  placeholder?: string
}

/**
 * UIInputRing - Ring Input Block
 * 포커스 시 강조 효과가 있는 입력 필드 컴포넌트입니다.
 * 포커스 시 강조된 링 효과가 있는 입력 필드입니다.
 */
export const UIInputRing = React.forwardRef<HTMLInputElement, UIInputRingProps>(
  ({
    type = "email",
    placeholder,
    className,
    ...props
  }, ref) => {
    const t = useTranslations('components.forms')

    return (
      <UIInput
        ref={ref}
        type={type}
        placeholder={placeholder || t('input.email.placeholder')}
        className={cn(
          "max-w-xs focus-visible:ring-[3px] focus-visible:ring-blue-500/20 focus-visible:border-blue-500",
          className
        )}
        {...props}
      />
    )
  }
)

UIInputRing.displayName = "UIInputRing"